import { useEffect, useState } from 'react'

import {
  UseBase64Conversion,
  UseBase64ConversionParams,
} from '../types/use-base64-conversion'

const useBase64Conversion = ({
  asset,
}: UseBase64ConversionParams): UseBase64Conversion => {
  const [blobUrl, setBlobUrl] = useState<string | null>(null)
  const [invalidBlobUrl, setinvalidBlobUrl] = useState(false)
  const [blobDownloading, setBlobDownloading] = useState(false)

  useEffect(() => {
    const b64toUrl = async (base64Data: string): Promise<void> => {
      try {
        setinvalidBlobUrl(false)
        setBlobDownloading(true)
        const r = await fetch(base64Data)

        const blob = await r.blob()

        setBlobUrl(URL.createObjectURL(blob))
      } catch (error) {
        setinvalidBlobUrl(true)
      } finally {
        setBlobDownloading(false)
      }
    }

    if (asset.data) {
      b64toUrl(asset.data)
    }
  }, [])

  return {
    blobUrl,
    invalidBlobUrl,
    blobDownloading,
  }
}

export default useBase64Conversion
